import { DELETE_ROTATIONSPLAN_VORLAGE } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteRotationsplanVorlage/mutation';
import { ROTATIONSPLAN_VORLAGEN } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanVorlagen/graphql/queries';
import {
  Mitarbeiter_DeleteRotationsplanVorlageMutation,
  Mitarbeiter_DeleteRotationsplanVorlageMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useDeleteRotationsplanVorlage() {
  const [execute, result] = useMutation<
    Mitarbeiter_DeleteRotationsplanVorlageMutation,
    Mitarbeiter_DeleteRotationsplanVorlageMutationVariables
  >(DELETE_ROTATIONSPLAN_VORLAGE, {
    // not the details query: the deleted vorlage would turn into "nicht gefunden" before leaving the page.
    // passed as document (not by name) so the list is refetched even when deleting from the details page,
    // where the list query is not active
    refetchQueries: [{ query: ROTATIONSPLAN_VORLAGEN }],
    awaitRefetchQueries: true,
  });

  const deleteRotationsplanVorlage = useCallback(
    (variables: Mitarbeiter_DeleteRotationsplanVorlageMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [deleteRotationsplanVorlage, result] as const;
}
